﻿<template>
  <el-dialog
    :visible.sync="visible"
    width="650px"
    top="21vh"
    custom-class="figma-community-dialog"
    :show-close="false"
    :close-on-click-modal="false"
    @close="clearAddCommunityInfo"
  >
    <div slot="title" class="figma-dialog-header">
      <span class="figma-dialog-title">{{ $t("addCommunity.title") }}</span>
      <img
        src="../../../assets/CodeBuddyAssets/616_12573/31.svg"
        class="figma-dialog-divider"
      />
    </div>

    <el-form
      ref="form"
      :model="addCommunityInfo"
      :rules="rules"
      label-width="86px"
      class="figma-community-form"
      size="small"
    >
      <el-form-item :label="$t('addCommunity.name') + ':'" prop="name" required>
        <el-input
          v-model="addCommunityInfo.name"
          :placeholder="$t('addCommunity.inputPlaceholder')"
          class="figma-form-input"
        />
      </el-form-item>
      <el-form-item
        :label="$t('addCommunity.province') + ':'"
        prop="provinceCode"
        required
      >
        <el-select
          v-model="addCommunityInfo.provinceCode"
          :placeholder="$t('addCommunity.selectPlaceholder')"
          class="figma-form-input"
          @change="handleProvChange"
        >
          <el-option
            v-for="item in areaOptions.provs"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('addCommunity.city') + ':'"
        prop="cityCode"
        required
      >
        <el-select
          v-model="addCommunityInfo.cityCode"
          :placeholder="$t('addCommunity.selectPlaceholder')"
          class="figma-form-input"
          :disabled="!addCommunityInfo.provinceCode"
          @change="handleCityChange"
        >
          <el-option
            v-for="item in areaOptions.citys"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('addCommunity.areaName') + ':'"
        prop="districtCode"
        required
      >
        <el-select
          v-model="addCommunityInfo.districtCode"
          :placeholder="$t('addCommunity.selectPlaceholder')"
          class="figma-form-input"
          :disabled="!addCommunityInfo.cityCode"
          @change="handleAreaChange"
        >
          <el-option
            v-for="item in areaOptions.areas"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('addCommunity.address') + ':'"
        prop="address"
        required
      >
        <el-input
          v-model="addCommunityInfo.address"
          :placeholder="$t('addCommunity.inputPlaceholder')"
          class="figma-form-input"
        />
      </el-form-item>
      <el-form-item
        :label="$t('addCommunity.voteReminder') + ':'"
        prop="voteReminder"
      >
        <el-switch
          v-model="addCommunityInfo.voteReminder"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="Y"
          inactive-value="N"
        >
        </el-switch>
      </el-form-item>
      <!-- <el-form-item :label="$t('addCommunity.status') + ':'" prop="isOpen" required class="figma-status-form-item">
        <el-radio-group v-model="addCommunityInfo.isOpen" class="figma-status-radio">
          <el-radio label="1">{{ $t('communityManage.search.stateNormal') }}</el-radio>
          <el-radio label="0">{{ $t('communityManage.search.stateDisabled') }}</el-radio>
        </el-radio-group>
      </el-form-item> -->
    </el-form>

    <div slot="footer" class="figma-dialog-footer">
      <el-button
        size="small"
        class="figma-btn-cancel"
        @click="visible = false"
        >{{ $t("common.cancel") }}</el-button
      >
      <el-button
        size="small"
        class="figma-btn-confirm"
        @click="saveCommunityInfo"
        >{{ $t("common.confirm") }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { saveCommunity, listAreas } from "@/api/community/communityManageApi";

export default {
  name: "AddCommunity",
  data() {
    return {
      visible: false,
      areaOptions: {
        provs: [],
        citys: [],
        areas: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("addCommunity.validate.name"),
            trigger: "blur",
          },
        ],
        provinceCode: [
          {
            required: true,
            message: this.$t("addCommunity.validate.province"),
            trigger: "change",
          },
        ],
        cityCode: [
          {
            required: true,
            message: this.$t("addCommunity.validate.city"),
            trigger: "change",
          },
        ],
        districtCode: [
          {
            required: true,
            message: this.$t("addCommunity.validate.area"),
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("addCommunity.validate.address"),
            trigger: "blur",
          },
        ],
      },
      addCommunityInfo: this.getDefaultCommunityInfo(),
    };
  },
  methods: {
    getDefaultCommunityInfo() {
      return {
        name: "",
        provinceCode: "",
        provinceName: "",
        cityCode: "",
        cityName: "",
        districtCode: "",
        districtName: "",
        address: "",
        isOpen: "1",
        mapX: "101.33",
        mapY: "101.33",
        voteReminder: "N",
      };
    },
    openModal() {
      this.clearAddCommunityInfo();
      this.visible = true;
      this.loadAreas("101", "0", "provs");
    },
    loadAreas(areaLevel, parentAreaCode, key) {
      listAreas({ areaLevel, parentAreaCode })
        .then((res) => {
          this.areaOptions[key] = res.areas || [];
        })
        .catch((error) => {
          console.error("查询地区失败", error);
          this.$message.error(this.$t("areaSelect.fetchError"));
        });
    },
    handleProvChange(value) {
      const current = this.areaOptions.provs.find(
        (item) => item.areaCode === value,
      );
      this.addCommunityInfo.provinceName = current ? current.areaName : "";
      this.addCommunityInfo.cityCode = "";
      this.addCommunityInfo.cityName = "";
      this.addCommunityInfo.districtCode = "";
      this.addCommunityInfo.districtName = "";
      this.areaOptions.citys = [];
      this.areaOptions.areas = [];
      if (value) this.loadAreas("202", value, "citys");
    },
    handleCityChange(value) {
      const current = this.areaOptions.citys.find(
        (item) => item.areaCode === value,
      );
      this.addCommunityInfo.cityName = current ? current.areaName : "";
      this.addCommunityInfo.districtCode = "";
      this.addCommunityInfo.districtName = "";
      this.areaOptions.areas = [];
      if (value) this.loadAreas("303", value, "areas");
    },
    handleAreaChange(value) {
      const current = this.areaOptions.areas.find(
        (item) => item.areaCode === value,
      );
      this.addCommunityInfo.districtName = current ? current.areaName : "";
    },
    saveCommunityInfo() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const data = { ...this.addCommunityInfo };
        data.isOpen = "0";
        saveCommunity(data)
          .then((res) => {
            this.$message.success(this.$t("common.operationSuccess"));
            this.visible = false;
            const communityId = (res && res.communityId) || data.communityId || '';
            this.$emit("listData", { communityId, voteReminder: data.voteReminder, isNew: true });
          })
          .catch((error) => {
            this.$message.error(error.message);
          });
      });
    },
    clearAddCommunityInfo() {
      this.addCommunityInfo = this.getDefaultCommunityInfo();
      this.areaOptions.citys = [];
      this.areaOptions.areas = [];
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
  },
};
</script>

<style scoped>
>>> .figma-community-dialog {
  width: 650px !important;
  border-radius: 12px;
  overflow: hidden;
}

>>> .figma-community-dialog .el-dialog__header {
  height: 66px;
  padding: 0;
  background: #ebf2fa;
}

>>> .figma-community-dialog .el-dialog__body {
  padding: 24px 24px 0;
}

>>> .figma-community-dialog .el-dialog__footer {
  padding: 24px 24px 28px;
}

.figma-dialog-header {
  position: relative;
  height: 66px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
}

.figma-dialog-title {
  color: #1d2129;
  font-size: 16px;
  font-weight: 600;
  font-family: "PingFang SC", sans-serif;
  line-height: 22px;
}

.figma-dialog-divider {
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 650px;
  height: 1px;
}

.figma-community-form >>> .el-form-item {
  margin-bottom: 20px;
}

.figma-community-form >>> .el-form-item__label {
  color: #1d2129;
  font-size: 14px;
  font-weight: 500;
  font-family: "PingFang SC", sans-serif;
  padding-right: 8px;
}

.figma-community-form
  >>> .el-form-item.is-required
  .el-form-item__label:before {
  color: #fb2c36;
  font-weight: 500;
}

.figma-form-input {
  width: 516px;
}

.figma-form-input >>> .el-input__inner {
  width: 516px;
  height: 38px;
  border: none;
  outline: 1px solid #dce6f5;
  outline-offset: -1px;
  border-radius: 10px;
  background: #ffffff;
  color: #1d2129;
  font-size: 14px;
  font-family: Inter, "PingFang SC", sans-serif;
  padding: 0 16px;
}

.figma-form-input >>> .el-input__inner:focus {
  outline-color: #0e76ff;
}

.figma-form-input >>> .el-input__inner::placeholder {
  color: #8c9bb4;
}

.figma-status-form-item {
  margin-bottom: 0 !important;
}

.figma-status-radio {
  height: 24px;
  display: flex;
  align-items: center;
  gap: 64px;
}

.figma-status-radio >>> .el-radio {
  color: #8c9bb4;
  font-size: 14px;
  font-weight: 500;
  font-family: "PingFang SC", sans-serif;
  margin-right: 0;
}

.figma-status-radio >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #0e76ff;
  background: #0e76ff;
}

.figma-status-radio >>> .el-radio__input.is-checked + .el-radio__label {
  color: #8c9bb4;
}

.figma-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.figma-btn-cancel,
.figma-btn-confirm {
  width: 98px;
  height: 38px;
  border-radius: 10px !important;
  font-size: 14px;
  font-weight: 500;
  font-family: "PingFang SC", sans-serif;
  padding: 0 !important;
}

.figma-btn-cancel {
  border: none !important;
  outline: 1px solid #0e76ff !important;
  outline-offset: -1px;
  background: #ffffff !important;
  color: #0e76ff !important;
}

.figma-btn-confirm {
  border: none !important;
  background: #0e76ff !important;
  color: #ffffff !important;
}
</style>
